module.exports = __webpack_public_path__ + "img/icon-payment-app.6700ec4a.png";